import { LastDateTimeRange } from '@modules/common/components/DateRangePicker/types';
import { mapToEdgeTimeUnit } from '@modules/common/utils/mapToEdgeTimeUnit';
import { DEFAULT_COMPARE_TO_PREVIOUS_PERIOD } from '@modules/quantify/constants';
import { CompareQueryProperty } from '@modules/quantify/store/types';

export const getCompareQueryPreviousPeriodFromDuration = (
  duration: LastDateTimeRange,
): Required<Pick<CompareQueryProperty, 'previousPeriod'>> &
  CompareQueryProperty => {
  return {
    previousPeriod: {
      unit: mapToEdgeTimeUnit(duration.unit),
      value:
        duration.value ??
        DEFAULT_COMPARE_TO_PREVIOUS_PERIOD.previousPeriod.value,
    },
  };
};
